import { render, staticRenderFns } from "./PubDidMediaTypeModal.vue?vue&type=template&id=b5afc0be&scoped=true"
import script from "./PubDidMediaTypeModal.vue?vue&type=script&lang=js"
export * from "./PubDidMediaTypeModal.vue?vue&type=script&lang=js"
import style0 from "./PubDidMediaTypeModal.vue?vue&type=style&index=0&id=b5afc0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5afc0be",
  null
  
)

export default component.exports